import { styled, Box } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  borderBottomRightRadius: theme.spacing(2),
  borderBottomLeftRadius: theme.spacing(2),
  backgroundColor: theme.palette.grey[800],
  display: 'flex',
  width: '83%',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 3),
  [theme.breakpoints.down('sm')]: {
    width: `calc(100% - ${theme.spacing(4)})`,
  },
}));
